import { chakra, EloCardPrimary, EloCardSecondary } from '@plurall/elo-v3';

import {
  feedbackAnalysisCardRecipe,
  feedbackAnalysisChartCardRecipe,
  feedbackAnalysisChartGridItemRecipe,
  feedbackAnalysisChartHeadingRecipe,
  feedbackAnalysisChartIconCardRecipe,
  feedbackAnalysisChartMobileBarFillRecipe,
  feedbackAnalysisChartMobileBarRowRecipe,
  feedbackAnalysisChartMobileBarTrackRecipe,
  feedbackAnalysisChartMobileItemRecipe,
  feedbackAnalysisChartMobileLabelRecipe,
  feedbackAnalysisChartMobileListRecipe,
  feedbackAnalysisChartMobileValueRecipe,
  feedbackAnalysisChartSectionRecipe,
  feedbackAnalysisChartWrapperRecipe,
  feedbackAnalysisContentGridRecipe,
  feedbackAnalysisContentSingleRecipe,
  feedbackAnalysisEmptyStateRecipe,
  feedbackAnalysisGeneroLabelRecipe,
  feedbackAnalysisGeneroSelectRecipe,
  feedbackAnalysisGeneroWrapperRecipe,
  feedbackAnalysisHeaderRecipe,
  feedbackAnalysisPanelCardRecipe,
  feedbackAnalysisSectionRecipe,
  feedbackAnalysisSkeletonRecipe,
  feedbackAnalysisStrengthItemCardRecipe,
  feedbackAnalysisStrengthItemIconCardRecipe,
  feedbackAnalysisStrengthItemRowRecipe,
  feedbackAnalysisStrengthItemsListRecipe,
  feedbackAnalysisStrengthsCardRecipe,
  feedbackAnalysisStrengthsHeadingRecipe,
  feedbackAnalysisStrengthsIconCardRecipe,
  feedbackAnalysisStrengthsRecipe,
  feedbackAnalysisStrengthsSubtitleRecipe,
  feedbackAnalysisStrengthsTextWrapperRecipe,
  feedbackAnalysisStrengthsTitleRecipe,
  feedbackAnalysisTabListRecipe,
  feedbackAnalysisTabsSkeletonRecipe,
  feedbackAnalysisTabTriggerRecipe,
} from './feedback-analysis.recipe';

export const FeedbackAnalysisCardRootFactory = chakra(EloCardPrimary.Root, feedbackAnalysisCardRecipe);
export const FeedbackAnalysisStrengthsCardFactory = chakra(EloCardSecondary.Root, feedbackAnalysisStrengthsCardRecipe);
export const FeedbackAnalysisChartCardFactory = chakra(EloCardSecondary.Root, feedbackAnalysisChartCardRecipe);
export const FeedbackAnalysisPanelCardFactory = chakra(EloCardSecondary.Root, feedbackAnalysisPanelCardRecipe);
export const FeedbackAnalysisStrengthItemCardFactory = chakra(
  EloCardSecondary.Root,
  feedbackAnalysisStrengthItemCardRecipe
);
export const FeedbackAnalysisEmptyStateFactory = chakra('div', feedbackAnalysisEmptyStateRecipe);
export const FeedbackAnalysisChartMobileListFactory = chakra('div', feedbackAnalysisChartMobileListRecipe);
export const FeedbackAnalysisChartMobileItemFactory = chakra('div', feedbackAnalysisChartMobileItemRecipe);
export const FeedbackAnalysisChartMobileLabelFactory = chakra('span', feedbackAnalysisChartMobileLabelRecipe);
export const FeedbackAnalysisChartMobileBarRowFactory = chakra('div', feedbackAnalysisChartMobileBarRowRecipe);
export const FeedbackAnalysisChartMobileBarTrackFactory = chakra('div', feedbackAnalysisChartMobileBarTrackRecipe);
export const FeedbackAnalysisChartMobileBarFillFactory = chakra('div', feedbackAnalysisChartMobileBarFillRecipe);
export const FeedbackAnalysisChartMobileValueFactory = chakra('span', feedbackAnalysisChartMobileValueRecipe);
export const FeedbackAnalysisSectionFactory = chakra('div', feedbackAnalysisSectionRecipe);
export const FeedbackAnalysisHeaderFactory = chakra('div', feedbackAnalysisHeaderRecipe);
export const FeedbackAnalysisTabListFactory = chakra('div', feedbackAnalysisTabListRecipe);
export const FeedbackAnalysisTabTriggerFactory = chakra('button', feedbackAnalysisTabTriggerRecipe);
export const FeedbackAnalysisContentGridFactory = chakra('div', feedbackAnalysisContentGridRecipe);
export const FeedbackAnalysisChartGridItemFactory = chakra('div', feedbackAnalysisChartGridItemRecipe);
export const FeedbackAnalysisContentSingleFactory = chakra('div', feedbackAnalysisContentSingleRecipe);
export const FeedbackAnalysisStrengthsFactory = chakra('div', feedbackAnalysisStrengthsRecipe);
export const FeedbackAnalysisStrengthsHeadingFactory = chakra('div', feedbackAnalysisStrengthsHeadingRecipe);
export const FeedbackAnalysisStrengthsIconCardFactory = chakra('div', feedbackAnalysisStrengthsIconCardRecipe);
export const FeedbackAnalysisStrengthsTextWrapperFactory = chakra('div', feedbackAnalysisStrengthsTextWrapperRecipe);
export const FeedbackAnalysisStrengthsTitleFactory = chakra('span', feedbackAnalysisStrengthsTitleRecipe);
export const FeedbackAnalysisStrengthsSubtitleFactory = chakra('span', feedbackAnalysisStrengthsSubtitleRecipe);
export const FeedbackAnalysisStrengthItemIconCardFactory = chakra('div', feedbackAnalysisStrengthItemIconCardRecipe);
export const FeedbackAnalysisStrengthItemRowFactory = chakra('div', feedbackAnalysisStrengthItemRowRecipe);
export const FeedbackAnalysisStrengthItemsListFactory = chakra('div', feedbackAnalysisStrengthItemsListRecipe);
export const FeedbackAnalysisChartSectionFactory = chakra('div', feedbackAnalysisChartSectionRecipe);
export const FeedbackAnalysisChartHeadingFactory = chakra('div', feedbackAnalysisChartHeadingRecipe);
export const FeedbackAnalysisChartIconCardFactory = chakra('div', feedbackAnalysisChartIconCardRecipe);
export const FeedbackAnalysisChartWrapperFactory = chakra('div', feedbackAnalysisChartWrapperRecipe);
export const FeedbackAnalysisSkeletonFactory = chakra('div', feedbackAnalysisSkeletonRecipe);
export const FeedbackAnalysisTabsSkeletonFactory = chakra('div', feedbackAnalysisTabsSkeletonRecipe);
export const FeedbackAnalysisGeneroWrapperFactory = chakra('div', feedbackAnalysisGeneroWrapperRecipe);
export const FeedbackAnalysisGeneroLabelFactory = chakra('span', feedbackAnalysisGeneroLabelRecipe);
export const FeedbackAnalysisGeneroSelectFactory = chakra('div', feedbackAnalysisGeneroSelectRecipe);
